/**
 * 旧 bt_popup-image-list の代替: 軽量なライトボックス。
 * data-gallery="<id>" でグループ化された <a> を見つけ、クリックで拡大表示。
 * 同 group 内なら左右 chevron で前後ナビできる。
 */
export function initLightbox() {
  const links = document.querySelectorAll('a[data-gallery]');
  if (!links.length) return;

  // gallery id → [link, ...] の辞書を作る
  const groups = new Map();
  links.forEach((a) => {
    const id = a.getAttribute("data-gallery");
    if (!groups.has(id)) groups.set(id, []);
    groups.get(id).push(a);
  });

  // モーダル DOM を1つだけ作る
  const overlay = document.createElement("div");
  overlay.className = "lightbox-overlay";
  overlay.hidden = true;
  overlay.innerHTML = `
    <button class="lightbox-close" type="button" aria-label="閉じる">×</button>
    <button class="lightbox-prev" type="button" aria-label="前へ">‹</button>
    <button class="lightbox-next" type="button" aria-label="次へ">›</button>
    <figure class="lightbox-figure">
      <img class="lightbox-image" alt="">
      <figcaption class="lightbox-caption"></figcaption>
    </figure>
  `;
  document.body.appendChild(overlay);

  const imgEl = overlay.querySelector(".lightbox-image");
  const capEl = overlay.querySelector(".lightbox-caption");
  const closeBtn = overlay.querySelector(".lightbox-close");
  const prevBtn = overlay.querySelector(".lightbox-prev");
  const nextBtn = overlay.querySelector(".lightbox-next");

  let current = { group: null, index: 0 };

  function open(group, index) {
    const items = groups.get(group);
    if (!items || !items[index]) return;
    current = { group, index };
    const link = items[index];
    imgEl.src = link.href;
    capEl.textContent = link.getAttribute("data-caption") || "";
    capEl.hidden = !capEl.textContent;
    // 1つしかない場合はナビ非表示
    const showNav = items.length > 1;
    prevBtn.hidden = !showNav;
    nextBtn.hidden = !showNav;
    overlay.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function close() {
    overlay.hidden = true;
    document.body.style.overflow = "";
  }

  function step(delta) {
    const items = groups.get(current.group);
    if (!items) return;
    const next = (current.index + delta + items.length) % items.length;
    open(current.group, next);
  }

  // リンク → モーダル
  links.forEach((a) => {
    a.addEventListener("click", (e) => {
      e.preventDefault();
      const id = a.getAttribute("data-gallery");
      const items = groups.get(id);
      if (!items) return;
      const index = items.indexOf(a);
      open(id, index < 0 ? 0 : index);
    });
  });

  // 操作
  closeBtn.addEventListener("click", close);
  prevBtn.addEventListener("click", () => step(-1));
  nextBtn.addEventListener("click", () => step(1));
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) close();
  });
  document.addEventListener("keydown", (e) => {
    if (overlay.hidden) return;
    if (e.key === "Escape") close();
    if (e.key === "ArrowLeft") step(-1);
    if (e.key === "ArrowRight") step(1);
  });
}
